// extracted by mini-css-extract-plugin
module.exports = {"tip-wrapper":"style_tip-wrapper__jsIh4","tip-hint":"style_tip-hint__SvFSO","tip-highlight":"style_tip-highlight___KoPH"};